import * as React from 'react';
import { ActionButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { getCalendarPath, getTodoModuleUrl } from 'owa-url';
import { getPanelViewType, getStackLength } from '../selectors/timePanelStoreSelectors';
import { observer } from 'mobx-react';
import { openDeeplink, popView, updatePanelView } from '../actions/timePanelStoreActions';
import { Pivot, PivotItem, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';

const styles = require('./TimePanelHeaderBar.scss');

@observer
export default class TimePanelHeaderBar extends React.Component<{}, {}> {
    render() {
        let content: JSX.Element;
        const stackLength = getStackLength();
        if (stackLength > 1) {
            content = (
                <ActionButton
                    className={styles.backButton}
                    styles={{
                        icon: styles.backButtonIcon,
                    }}
                    text={'Back'} // TODO VSO 43310 localize
                    onClick={this.onClickBackButton}
                    iconProps={{ iconName: ControlIcons.Back }}
                />
            );
        } else {
            const panelView = getPanelViewType();
            content = (
                <>
                    <div className={styles.pivot}>
                        <Pivot
                            onLinkClick={this.selectPivot}
                            linkSize={PivotLinkSize.normal}
                            selectedKey={panelView}
                            styles={{
                                linkIsSelected: styles.pivotLinkSelected,
                            }}>
                            <PivotItem
                                linkText={'Calendar'} // TODO VSO 43310 localize
                                itemKey={'Calendar'}
                            />
                            <PivotItem
                                linkText={'Tasks'} // TODO VSO 43310 localize
                                itemKey={'Tasks'}
                            />
                        </Pivot>
                    </div>
                    <div className={styles.buttonWellContainer}>
                        <IconButton
                            title={panelView === 'Calendar' ? 'Open Calendar' : 'Open Tasks'} // TODO VSO 43310 localize
                            iconProps={{ iconName: ControlIcons.OpenInNewWindow }}
                            href={panelView === 'Calendar' ? getCalendarPath() : getTodoModuleUrl()}
                            target={'_blank'}
                            styles={{
                                root: styles.openInNewWindowButton,
                            }}
                            onClick={
                                panelView === 'Calendar'
                                    ? this.onClickCalendarModuleDeeplink
                                    : this.onClickTasksModuleDeeplink
                            }
                        />
                    </div>
                </>
            );
        }
        return <div className={styles.container}>{content}</div>;
    }

    private selectPivot(item: PivotItem): void {
        switch (item.props.itemKey) {
            case 'Tasks':
            case 'Calendar':
                updatePanelView(item.props.itemKey);
                break;
            default:
                throw new Error('Not a valid ItemKey: ' + item.props.itemKey);
        }
    }

    private onClickBackButton(): void {
        popView();
    }

    private onClickCalendarModuleDeeplink = () => {
        openDeeplink('CalendarModule');
    };

    private onClickTasksModuleDeeplink = () => {
        openDeeplink('TasksModule');
    };
}
